var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVariableMappingsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.825,
    height: 137,
    viewBox: "0 0 147.825 137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-state-VM",
    transform: "translate(-100 -32.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    d: "M224.35,56.837V160.754a4.016,4.016,0,0,1-4.017,4.017H127.472a4.016,4.016,0,0,1-4.017-4.017V36.617a4.017,4.017,0,0,1,4.017-4.017H200.12a5.548,5.548,0,0,1,1.409,1.016l21.8,21.8A5.4,5.4,0,0,1,224.35,56.837Z",
    fill: "#f8f9fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    "data-name": "Path 4102",
    d: "M224.451,57.047H207.428a7.519,7.519,0,0,1-7.517-7.521V32.5c.072.035.141.065.21.1a5.548,5.548,0,0,1,1.409,1.016l21.8,21.8a5.417,5.417,0,0,1,1.023,1.416c.034.069.065.141.1.214Z",
    fill: "#ebeff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4103",
    "data-name": "Path 4103",
    d: "M160.523,53.709h-4.316a3.227,3.227,0,0,0-3.273,3.263v9.35",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    "data-name": "Path 4104",
    d: "M171.28,80.688V73.942A7.282,7.282,0,0,0,164,66.659H151.587a7.28,7.28,0,0,0-7.283,7.283v6.746",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    "data-name": "Path 4105",
    d: "M150.236,101.19V98.5a3.061,3.061,0,0,0-3.2-2.9h-5.46a3.061,3.061,0,0,0-3.2,2.9v2.687",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    "data-name": "Path 4106",
    d: "M177.215,101.19V98.5a3.061,3.061,0,0,0-3.2-2.9h-5.46a3.061,3.061,0,0,0-3.2,2.9v2.687",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4107",
    "data-name": "Path 4107",
    d: "M144.3,89.353v6.715",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4108",
    "data-name": "Path 4108",
    d: "M171.279,89.353v6.715",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    d: "M202.565,78.418h5.412l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    d: "M202.565,99.023h5.412l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    d: "M178.294,81.766H164.265a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.617,1.617,0,0,0,1.619-1.619V83.385A1.617,1.617,0,0,0,178.294,81.766Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    d: "M178.294,83.331H164.265a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.617,1.617,0,0,0,1.619-1.619V84.95A1.617,1.617,0,0,0,178.294,83.331Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M212.288,102.272H198.259a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.617,1.617,0,0,0,1.619-1.619v-2.157A1.618,1.618,0,0,0,212.288,102.272Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M151.315,81.766H137.286a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.617,1.617,0,0,0,1.619-1.619V83.385A1.617,1.617,0,0,0,151.315,81.766Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    d: "M139.443,102.272h-2.157a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h2.157a1.617,1.617,0,0,0,1.619-1.619v-2.157A1.617,1.617,0,0,0,139.443,102.272Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    d: "M166.422,102.272h-2.157a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h2.157a1.617,1.617,0,0,0,1.619-1.619v-2.157A1.617,1.617,0,0,0,166.422,102.272Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M151.314,102.272h-2.156a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h2.156a1.617,1.617,0,0,0,1.62-1.619v-2.157A1.618,1.618,0,0,0,151.314,102.272Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M178.294,102.272h-2.157a1.618,1.618,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h2.157a1.617,1.617,0,0,0,1.619-1.619v-2.157A1.617,1.617,0,0,0,178.294,102.272Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4119",
    "data-name": "Path 4119",
    d: "M191.207,54.246h5.164a8.9,8.9,0,0,1,8.9,8.9V99.154",
    fill: "none",
    stroke: "#d8e4f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4120",
    "data-name": "Path 4120",
    d: "M188.006,44.534H162.1a2.7,2.7,0,0,0-2.7,2.7V59.1a2.7,2.7,0,0,0,2.7,2.7h25.9a2.7,2.7,0,0,0,2.7-2.7V47.232A2.7,2.7,0,0,0,188.006,44.534Z",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4121",
    "data-name": "Path 4121",
    d: "M180.182,50.47h-10.79a.81.81,0,1,0,0,1.619h10.79a.81.81,0,1,0,0-1.619Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4122",
    "data-name": "Path 4122",
    d: "M183.958,53.709h-17.8a.81.81,0,1,0,0,1.619h17.8a.81.81,0,0,0,0-1.619Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4123",
    "data-name": "Path 4123",
    d: "M141.592,78.418h5.413L144.3,81.126Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4124",
    "data-name": "Path 4124",
    d: "M135.656,99.023h5.413l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4125",
    "data-name": "Path 4125",
    d: "M162.628,99.023h5.413l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4126",
    "data-name": "Path 4126",
    d: "M147.529,99.023h5.412l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4127",
    "data-name": "Path 4127",
    d: "M174.5,99.023h5.412l-2.707,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4128",
    "data-name": "Path 4128",
    d: "M168.571,78.418h5.413l-2.708,2.708Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M142.949,87.161a1.35,1.35,0,1,0,1.351-1.351A1.351,1.351,0,0,0,142.949,87.161Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M158.061,53.709a1.35,1.35,0,1,0,1.35-1.35A1.35,1.35,0,0,0,158.061,53.709Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M169.929,87.161a1.351,1.351,0,1,0,1.351-1.351A1.351,1.351,0,0,0,169.929,87.161Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M212.288,81.766H198.259a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.618,1.618,0,0,0,1.619-1.619V83.385A1.618,1.618,0,0,0,212.288,81.766Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4133",
    "data-name": "Path 4133",
    d: "M212.288,83.331H198.259a1.617,1.617,0,0,0-1.619,1.619v2.157a1.617,1.617,0,0,0,1.619,1.619h14.029a1.618,1.618,0,0,0,1.619-1.619V84.95A1.618,1.618,0,0,0,212.288,83.331Z",
    fill: "#d8e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4134",
    "data-name": "Path 4134",
    d: "M247.825,93.032v68.926a7.563,7.563,0,0,1-7.582,7.542H107.582A7.563,7.563,0,0,1,100,161.958V78.285c0-3.778,2.576-6.84,5.75-6.84h48.6a5.857,5.857,0,0,1,5.344,4.309l3.258,9.737h77.292A7.562,7.562,0,0,1,247.825,93.032Z",
    fill: "#e6ebf4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableMappingsEmptyState);
export default __webpack_public_path__ + "static/media/variable-mappings-empty-state.f1b6a85235a69f04dfb0d3a08c672c7e.svg";
export { ForwardRef as ReactComponent };